import React from "react";
import { useUser } from "src/shared/context/UserContext";
import { formatNumber } from "../../OrderSearch";
import { Order } from "src/shared/services/interfacev2";
import { User, Info } from "lucide-react";

interface Props {
  orderId: string;
  customerName: string;
  order: Order | undefined;
}

const OrderCustomerInfo: React.FC<Props> = ({ orderId, customerName, order }) => {
  const { userConfigration } = useUser();

  const toBoolean = (value: any) => value === true || value === "true";
  const billNoEnabled = toBoolean(userConfigration?.billNoEnabled);
  const orderIdEnabled = toBoolean(userConfigration?.orderIdEnabled);

  const billNumber = order?.orders?.[order.orders.length - 1]?.billNumber;

  return (
    <div className="bg-white border border-slate-200 rounded-xl p-1.5 shadow-sm mb-1 transition-all hover:shadow-md">
      {/* Customer Identity Section */}
      <div className="flex items-center gap-4 mb-1 pb-1 border-b border-slate-50">
        <div className="flex-shrink-0 w-10 h-10 bg-slate-900 rounded-2xl flex items-center justify-center text-white shadow-lg shadow-slate-200">
          <User className="w-5 h-5" />
        </div>
        <div className="flex flex-col">
          <span className="text-[10px] font-black uppercase tracking-[0.15em] text-slate-400">Customer Name</span>
          <h2 className="text-xl font-black text-slate-800 tracking-tight leading-tight">{customerName || "Walk-in Customer"}</h2>
        </div>
      </div>

      {/* Metadata Row (Order ID & Bill No) */}
      {orderIdEnabled || billNoEnabled ? (
        <div className="flex items-center justify-between px-2 py-1 bg-slate-50 border border-slate-100 rounded-xl group shadow-sm">
          {/* Order ID Section */}
          {orderIdEnabled && (
            <div className="flex items-center gap-2">
              <span className="text-[10px] font-black uppercase tracking-widest text-slate-400">OrderId :</span>
              <span className="text-sm font-bold text-slate-800">{orderId}</span>
            </div>
          )}

          {/* Vertical Divider (Only shows if both are enabled) */}
          {orderIdEnabled && billNoEnabled && <div className="h-4 w-[1px] bg-slate-200 mx-2" />}

          {/* Bill Number Section */}
          {billNoEnabled && (
            <div className="flex items-center gap-2">
              <span className="text-[10px] font-black uppercase tracking-widest text-slate-400">Bill No. :</span>
              <span className="text-sm font-bold text-slate-800">{billNumber != null ? formatNumber(billNumber) : "—"}</span>
            </div>
          )}
        </div>
      ) : (
        /* Empty State */
        <div className="flex items-center gap-2 py-3 px-4 bg-amber-50/50 rounded-2xl text-amber-600 border border-amber-100/50">
          <Info className="w-4 h-4" />
          <span className="text-[10px] font-bold uppercase tracking-wider">References Hidden</span>
        </div>
      )}
    </div>
  );
};

export default OrderCustomerInfo;
